<template lang="pug">
.ber-map
  .map-container 
    .map(ref="mapRef")
    .ratings.cards(v-if="berRatings")
      BERMapRating(:label="$t('berMap.bestInArea')", :rating="berRatings.best")
      BERMapRating(:label="$t('berMap.avgInArea')", :rating="berRatings.mean")
  div(ref="markerRef")
    MapMarker
  
</template>

<script lang="ts">
import { useMap, useMapMarker } from "@/composeables";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import MapMarker from "./MapMarker.vue";
import BERMapRating from "./BERMapRating.vue";
import { useBerRatings } from "@/store/map-ber-rating";
import { storeToRefs } from "pinia";
import { useSelections } from "@/store";

export default defineComponent({
  components: { MapMarker, BERMapRating },
  setup() {
    const { initializeMap } = useMap();
    const mapMarker = useMapMarker();
    const berRatingsStore = useBerRatings();
    const { addressResult } = storeToRefs(useSelections());
    const { berRatings, coords } = storeToRefs(berRatingsStore);

    const mapRef = ref<HTMLDivElement>();
    const markerRef = ref<HTMLDivElement>();

    watch(
      computed(() => coords.value),
      (x) => {
        if (x) mapMarker.place(x, true);
      }
    );

    onMounted(async () => {
      if (!mapRef.value || !markerRef.value) return;

      const map = initializeMap(mapRef.value);

      mapMarker.initPanelMarker(map, markerRef.value);

      if (addressResult.value?.data?.location) {
        const { latitude, longitude } = addressResult.value.data.location;
        mapMarker.place({ lat: latitude, lng: longitude }, false, 16);
      }

      map.on("click", ({ lngLat }) =>
        berRatingsStore.loadBerRatingByCoords(lngLat.lat, lngLat.lng)
      );
    });

    return { berRatings, mapRef, markerRef };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/components/ber-rating.scss";
.ber-map {
  height: 100%;
  width: 100%;
  // max-width: 82rem;
  .map-container {
    width: 100%;
    height: 42rem;
    padding: 0.25rem;
    background-color: white;
    position: relative;

    .map {
      height: 100%;
    }

    .ratings {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      width: 14rem;
      position: absolute;
      top: 1rem;
      right: 1rem;
      background-color: #ffffffcc;
      padding: 1.25rem 1.25rem 2rem 1.25rem;
    }
  }
}
</style>
